import { DeleteDocuments } from '@/connection/content/documents';
import { RootState } from '@/store/main';
import { ContentReducerCreator, ContentState } from '../types';
import { cannotDeleteToast } from '../utils';

const deleteDocumentsReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number, { getState }) => {
      const state = (getState() as RootState).content as ContentState;
      return await DeleteDocuments(channel, Object.keys(state.contentMarkedForDeletion).map(Number));
    },
    {
      fulfilled: (state, action) => {
        if (action.payload.cannotDelete.length) {
          const cannotDeleteSet = new Set(action.payload.cannotDelete || []);

          const errorMessage =
            state.documents
              ?.filter((doc) => cannotDeleteSet.has(doc.document))
              .map((doc) => doc.display_name)
              .join(', ') || '';
          cannotDeleteToast(errorMessage);
        }

        if (state.documents) {
          state.documents = state.documents.filter((doc) => !action.payload.deletedDocuments.includes(doc.document));
          state.contentMarkedForDeletion = {};
        }
      },
    }
  );
};

export default deleteDocumentsReducer;
